export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=8d6c5a4a"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/games/index.vue?vue&type=template&id=8d6c5a4a
// module id = enXT
// module chunks = 0